import React from "react";
import "./Header.css";
import ProfileIcon from "../../../assets/icons/profile.svg";
import { useLocalization } from "../../../context/LocalizationContext";
import { convertToArabicNumerals } from "../../../utils/helpers";

const Header = ({ text, userData }) => {
  const { t, isRTL } = useLocalization();

  const getLocalizedGender = (gender) => {
    return gender.toLowerCase() == "male" ? t("male") : t("female");
  };

  const getLocalizedAge = (age) => {
    return isRTL ? convertToArabicNumerals(age) : age;
  };
  return (
    <div className="welcome-section">
      <div className="header-content">
        <div className="left-section">
          <h1 className="welcome-text">{text}</h1>
        </div>
        {userData && (
          <div className="profile-section">
            <div className="profile-info">
              <h3
                className="profile-name"
                style={{ textAlign: isRTL ? "left" : "right" }}
              >
                {userData?.name}
              </h3>
              <p className="profile-details">
                {getLocalizedGender(userData?.gender)},{" "}
                {getLocalizedAge(userData?.age)} {t("years")}
              </p>
            </div>
            <div className="profile-avatar">
              <img src={ProfileIcon} alt="Profile" />
            </div>
          </div>
        )}
      </div>
      <div className="progress-line">
        <div className="progress-active"></div>
      </div>
    </div>
  );
};

export default Header;
